var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NgZone, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material';
import { TranslateService } from '../../../../../../services/translate.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { NotificationsService } from '../../../../../common/services/notifications.service';
import { UserService } from '../../../../../../services/user.service';
import { WksCentralService } from '../../../../services/wks-central.service';
import { PartsStock, WksWorksModel, WorkEquipments, WorkInputEvent, WorkJsonData } from '../../../../models/wks-works.model';
import { TaskrefJsonModel, WksTasksModel } from '../../../../models/wks-param.model';
import { InternationalsFormats } from '../../../../../../models/data.model';
import { RessourcesService } from '../../../../../../job/common/services/ressources.service';
import { CommonMethods } from '../../../../../../job/common/tools/commonMethods';
import { WksWorksService } from '../../../..//services/wks-works.service';
export class WorksStockMovementsComponent {
    constructor(_userService, _translateService, _wksCentralService, _notificationsService, _ressourcesService, toastr, _zone, snackBar, _dialog, _wksWorksService) {
        this._userService = _userService;
        this._translateService = _translateService;
        this._wksCentralService = _wksCentralService;
        this._notificationsService = _notificationsService;
        this._ressourcesService = _ressourcesService;
        this.toastr = toastr;
        this._zone = _zone;
        this.snackBar = snackBar;
        this._dialog = _dialog;
        this._wksWorksService = _wksWorksService;
        this.onDestroy = new Subject();
    }
    ngOnInit() {
        if (this._userService.getUserLogged() === undefined) {
            return;
        }
        this.initAllBooleaans();
        this.initAllParam();
        this.settingFormats();
        this.initVariables();
        this.subscribeNotifications();
        this.getWorksList('wharehouseMan-new', 0);
        this.initializeScreen = true;
    }
    initAllBooleaans() {
        this.initializeScreen = false;
        this.displayParts = false;
        this.isOkToReserve = false;
        this.isLoadingData = true;
        this.displayErrorMsg = false;
        this.readStock = false;
        this.readOnly = false;
    }
    initVariables() {
        this.tabSelected = 0;
        this.timeFormat = this._translateService.getLocalFmt('timeFormat');
        this.rowsWorks = [];
        this.dataLabelCur = [];
        this.dataLabelCur[0] = this._translateService.instant('suppliesLabel');
        this.dataLabelCur[1] = this._translateService.instant('brandRef');
        this.dataLabelCur[2] = this._translateService.instant('replacesReference');
        this.dataLabelCur[3] = this._translateService.instant('billingUnit');
        this.dataLabelCur[4] = this._translateService.instant('quantity');
        this.dataLabelCur[5] = this._translateService.instant('actionTask');
        this.dataLabelCur[6] = this._translateService.instant('inStock');
        this.dataLabelCur[7] = this._translateService.instant('okToReserve');
        this.dataLabelCur[8] = this._translateService.instant('nws_order_ref');
        this.labelsTabs = [];
        this.labelsTabs[0] = 'deliveriesNew';
        this.labelsTabs[1] = 'deliveriesWaiting';
        this.labelsTabs[2] = 'deliveriesArchives';
    }
    settingFormats() {
        const otherData = JSON.parse(this._wksCentralService.getWksEntityCur().otherData);
        const intFormat = otherData.internationnalFormat;
        this.numberFormat = {
            locale: this._ressourcesService.getFormat(intFormat, 'numbers', 'locale'),
            minDecimal: this._ressourcesService.getFormat(intFormat, 'numbers', 'minimumFractionDigits'),
            maxDecimal: this._ressourcesService.getFormat(intFormat, 'numbers', 'maximumFractionDigits'),
            currency: this._ressourcesService.getFormat(intFormat, 'numbers', 'currency'),
        };
    }
    initAllParam() {
        this.wksEntity = this._wksCentralService.getWksEntityCur();
        const otherData = JSON.parse(this.wksEntity.otherData);
        const internationnalFormat = otherData.internationnalFormat;
        this.internationalsFormats = this._ressourcesService.getIntFormat(internationnalFormat);
        for (const fmtCur of this.internationalsFormats.datetime) {
            if (fmtCur.name === 'dateFormat') {
                this.dateFormat = fmtCur.value;
                this.dateFormatMoment = fmtCur.value;
                this.dateFormatMoment = this.dateFormatMoment.replace('dd', 'DD');
                this.dateFormatMoment = this.dateFormatMoment.replace('yyyy', 'YYYY');
            }
            if (fmtCur.name === 'timeFormat') {
                this.dateTimeFormat = fmtCur.value;
                this.dateTimeFormat = this.dateTimeFormat.replace('dd', 'DD');
                this.dateTimeFormat = this.dateTimeFormat.replace('yyyy', 'YYYY');
            }
        }
    }
    subscribeNotifications() {
        this.notificationsSubscription = this._notificationsService.connectNotif(this._userService.getUserLogged().usergroup)
            .pipe(takeUntil(this.onDestroy))
            .subscribe({
            next: notif => {
                this._zone.run(() => {
                    const msgData = JSON.parse(notif);
                    // console.log(msgData.recipients, ' ' + msgData.contentMessage);
                    if (msgData.recipients === this._userService.getUserLogged().entity && msgData.objectMessage === 'notifStock') {
                        const contentMsg = JSON.parse(msgData.contentMessage);
                        // this.dataSource.data.splice(0, 0, workMsg);
                        // this.rows = [...this.rows];
                        this.getWorkData(contentMsg.inflUuididentifier)
                            .then((workData) => {
                            if (workData.workStatut === 'accepted' || workData.workStatut === 'approved') {
                                const rowsList = JSON.parse(JSON.stringify(this.rowsWorks));
                                const rowData = [contentMsg, workData];
                                const newRow = this.buildRowWork('wharehouseMan-new', rowData);
                                rowsList.unshift(newRow);
                                this.rowsWorks = [...rowsList];
                                // this.rowsWorks.splice(0, 0, newRow);
                                this.settingOddEven();
                            }
                            setTimeout(() => { }, 500); // JLG - 2025-06-04 : nécessaire pour éviter une reconnexion immédiate au serveur qui génère l'erreur 503
                            //  this.cd.detectChanges(); // Forcer Angular à re-vérifier la vue
                            // const messageCur = this._translate.getTranslate('work') + ' : ' + workMsg.workRef + ' --- > ' + this._translate.getTranslate(workMsg.workStatut);
                            // this.openSnackBar(messageCur, 'No-Action');
                        });
                    }
                });
            }
        });
    }
    buildRowWork(_inflAppli, rowData) {
        const wksInfolinks = rowData[0];
        const workData = rowData[1];
        let dateOperationTmp;
        // const zuluDate = new Date(wksInfolinks.stdCreation);
        // console.log(zuluDate.toString()); // ou .toLocaleString() selon les besoins
        if (wksInfolinks.recordedDate.toString().includes('T')) {
            dateOperationTmp = CommonMethods.dateToString(wksInfolinks.recordedDate, 'unixM', this.timeFormat);
        }
        else {
            dateOperationTmp = CommonMethods.dateToString(wksInfolinks.recordedDate, 'json', this.timeFormat);
        }
        const partsStockTmp = {
            parts: undefined
        };
        const newRow = {
            workId: workData.id,
            workRef: workData.workRef,
            ownerId: workData.ownerId,
            ownerDesign: workData.workCustomerName,
            workLabel: workData.workObject,
            workStatut: workData.workStatut,
            // dateOperation: moment(wksInfolinks.stdCreation).format(environment.fmtDateTimeTZ),
            // dateOperation: GridTools.date_json('' + wksInfolinks.stdCreation, this._translateService.getLocalFmt('timeFormat')),
            dateOperation: dateOperationTmp,
            isSelected: false,
            isCollapsed: true,
            odd: false,
            isArchivable: false,
            workTasksList: [],
            partsStock: partsStockTmp,
            stdEntity: workData.stdEntity,
            work: workData,
            wksInfolinks: wksInfolinks
        };
        for (const taskCur of workData.workTasksContent) {
            const taskrefJson = JSON.parse(taskCur.taskrefJson);
            const tasksActionsContent = taskrefJson.tasksActionsContent;
            const taskEquipments = this._wksWorksService.getListEquipments(tasksActionsContent, workData.mainEquipmentObject, workData.subEquipmentsObject);
            const taskLocal = {
                workTask: taskCur,
                taskEquip: taskEquipments
            };
            newRow.partsStock.parts = this._wksWorksService.initListPartsFromTasks(workData);
            // newRow.partsRequirementTasks = this._wksWorksService.initListPartsFromTasks(workData);
            if (_inflAppli !== 'wharehouseMan-new') {
                if (workData.workJsonData) {
                    const workJsonData = JSON.parse(workData.workJsonData);
                    if (workJsonData.partsStock) {
                        newRow.partsStock = JSON.parse(JSON.stringify(workJsonData.partsStock));
                        newRow.isArchivable = this.ctrlIsArchivable(workJsonData.partsStock);
                    }
                }
            }
            newRow.workTasksList.push(taskLocal);
        }
        return newRow;
    }
    ctrlIsArchivable(partsStock) {
        let isArchivable = true;
        for (const itemPart of partsStock.parts) {
            const stockTransacts = itemPart.stockTransacts;
            let delivredQty = 0;
            for (const transact of stockTransacts) {
                delivredQty += transact.outputStock;
                delivredQty -= transact.inputStock;
            }
            if (delivredQty < itemPart.quantity) {
                isArchivable = false;
                break;
            }
        }
        return isArchivable;
    }
    // https://material.angular.io/components/snack-bar/overview
    // evolution : http://www.eduforbetterment.com/snackbar-model-in-angualr/
    // 2021-05 : https://stackblitz.com/edit/angular-material-snackbar-example
    // 2021-05 : https://stackblitz.com/edit/angular-snackbar
    openSnackBar(message, action) {
        let actionCur = action;
        if (action === 'No-Action') {
            actionCur = '';
        }
        this.snackBar.open(message, actionCur, {
            duration: 7000,
            panelClass: ['notif-works']
        });
    }
    selectedTabChange(origin, matTabSelected) {
        switch (matTabSelected.index) {
            case 0: { // new
                this.tabSelected = 0;
                this.readOnly = false;
                this.tabSelectedLoad();
                break;
            }
            case 1: { // waiting 
                this.tabSelected = 1;
                this.readOnly = false;
                this.tabSelectedLoad();
                break;
            }
            case 2: { // waiting 
                this.tabSelected = 2;
                this.readOnly = true;
                this.tabSelectedLoad();
                break;
            }
        }
    }
    tabSelectedLoad() {
        switch (this.tabSelected) {
            case 0: { // new
                this.getWorksList('wharehouseMan-new', this.tabSelected);
                break;
            }
            case 1: { // waiting 
                this.getWorksList('wharehouseMan-waiting', this.tabSelected);
                break;
            }
            case 2: { // waiting 
                this.getWorksList('wharehouseMan-history', this.tabSelected);
                break;
            }
        }
    }
    refresh() {
        this.tabSelectedLoad();
    }
    settingOddEven() {
        let i = 0;
        for (const item of this.rowsWorks) {
            item.odd = this.oddEven(i);
            i++;
        }
    }
    oddEven(idx) {
        return (idx % 2 !== 0 ? true : false);
    }
    currentTabSelected(tabName) {
        switch (tabName) {
            case 'deliveriesNew': {
                break;
            }
            case 'deliveriesWaiting': {
                break;
            }
            case 'deliveriesArchives': {
                break;
            }
        }
    }
    archiveRow(idx) {
        const wksInfolinks = this.rowsWorks[idx].wksInfolinks;
        this.displayParts = false;
        this.registerInflAppli(wksInfolinks, 'wharehouseMan-history', idx, true);
    }
    activeRow(idx) {
        const wksInfolinks = this.rowsWorks[idx].wksInfolinks;
        this.displayParts = false;
        this.registerInflAppli(wksInfolinks, 'wharehouseMan-waiting', idx, true);
    }
    copyWorkIdToClipBoard(idx) {
        const workId = this.rowsWorks[idx].workId;
        this._wksCentralService.copyToClipboard(workId);
        this.toastr.success(this._translateService.instant('workIdCopied'), workId, { positionClass: 'toast-center-center' });
    }
    setClickedWork(idx) {
        // this.rowsWorks[idx].isSelected = true;
        let i = 0;
        this.displayParts = false;
        for (const item of this.rowsWorks) {
            if (i === idx) {
                item.isSelected = true;
                this.displayListParts(i);
                i++;
                continue;
            }
            item.isSelected = false;
            item.isCollapsed = true;
            i++;
        }
    }
    displayListParts(idx) {
        // PartsRequirement[];
        this.idxToDisplay = idx;
        this.displayParts = true;
    }
    collapsedOther(idx, isCollapsed) {
        const nolocalCollapsed = !isCollapsed;
        let i = 0;
        for (const item of this.rowsWorks) {
            item.isSelected = false;
            if (i === idx) {
                if (nolocalCollapsed) {
                    item.isSelected = true;
                }
                i++;
                continue;
            }
            item.isCollapsed = true;
            i++;
        }
    }
    getWorkData(workId) {
        return __awaiter(this, void 0, void 0, function* () {
            const workData = yield this.getWorkUUID(this._userService.getUserLogged().entity, this._userService.getUserLogged().userlang, workId);
            return workData;
        });
    }
    getOwnerCur(ownerId) {
        this.getOwner(ownerId)
            .then((ownerReturn) => {
            const ownerCur = ownerReturn;
        }); // end customer
    }
    getOwner(ownerId) {
        return new Promise((resolve, reject) => {
            this._wksCentralService.getOwner(this._userService.getUserLogged().entity, ownerId)
                .pipe(takeUntil(this.onDestroy))
                .subscribe(data => {
                const ownerCur = data.body;
                resolve(ownerCur);
            }, err => {
                console.log('getOwner' + err.message);
                if (err.status === 404) {
                }
                reject(err.status);
            });
        });
    }
    getWorkUUID(_entity, _langUser, _uuid) {
        return new Promise((resolve, reject) => {
            this._wksCentralService.getWorksById(_entity, _langUser, _uuid)
                .subscribe(data => {
                const response = data.body;
                resolve(response);
            }, err => {
                console.log('getWorkUUID' + err.message);
                reject(err);
            });
        });
    }
    partSuppliesMovement($event) {
        // console.log(JSON.stringify($event));
        this.rowsWorks[$event.iRow].partsStock = $event.partsStock;
        const workCur = this.fillModel($event);
        this.registerWork(workCur, $event.iRow);
        this.registerInflAppli(this.rowsWorks[$event.iRow].wksInfolinks, $event.inflAppli, $event.iRow);
        if (this.ctrlIsArchivable(this.rowsWorks[$event.iRow].partsStock)) {
            this.archiveRow($event.iRow);
        }
    }
    getWorksList(_inflAppli, idxTab) {
        this.isLoadingData = true;
        this.displayErrorMsg = false;
        this.errorMsg = '';
        this.readStock = false;
        if (idxTab < 2) {
            this.readStock = true;
        }
        // this.cd.detectChanges(); // Forcer Angular à re-vérifier la vue
        this._wksCentralService.getInfolinksWorksList(this._userService.getUserLogged().entity, _inflAppli, this._userService.getUserLogged().userlang)
            .pipe(takeUntil(this.onDestroy))
            .subscribe(data => {
            const dataList = data.body;
            this.affectData(_inflAppli, dataList);
            this.isLoadingData = false;
        }, err => {
            this.rowsWorks = [];
            this.isLoadingData = false;
            this.errorMsg = this._translateService.getTranslate(this.labelsTabs[idxTab]) + ' : ' + this._translateService.getTranslate('noDataFound');
            this.displayErrorMsg = true;
            console.log(JSON.stringify(err));
        });
    }
    affectData(_inflAppli, dataList) {
        this.rowsWorks = [];
        for (const rowData of dataList) {
            const newRow = this.buildRowWork(_inflAppli, rowData);
            this.rowsWorks.push(newRow);
        }
        this.settingOddEven();
    }
    fillModel(eventMovenent) {
        const wksWorkCard = this.rowsWorks[eventMovenent.iRow].work;
        let workJsonData;
        if (wksWorkCard.workJsonData) {
            workJsonData = JSON.parse(wksWorkCard.workJsonData);
        }
        else {
            workJsonData = JSON.parse('{}');
        }
        if (eventMovenent) {
            workJsonData.partsStock = eventMovenent.partsStock;
        }
        wksWorkCard.workJsonData = JSON.stringify(workJsonData);
        return wksWorkCard;
    }
    registerWork(wksWorksCard, iRow) {
        this._wksCentralService.saveWksWorks(wksWorksCard, 'update')
            .subscribe(returnValue => {
            const wksWorksReturn = returnValue.body;
            this.rowsWorks[iRow].work = wksWorksReturn;
        }, (err) => {
            console.log(JSON.stringify(err));
        });
    }
    registerInflAppli(wksInfolinks, inflAppli, iRow, deleteRow) {
        const wksInfolinksTmp = JSON.parse(JSON.stringify(wksInfolinks));
        wksInfolinksTmp.inflAppli = inflAppli;
        this._wksCentralService.saveWksInfolinks(wksInfolinksTmp, 'updateLink')
            .subscribe(returnValue => {
            if (deleteRow) {
                this.rowsWorks.splice(iRow, 1);
            }
            else {
                const wksInfolinksReturn = returnValue.body;
                this.rowsWorks[iRow].wksInfolinks = wksInfolinksReturn;
            }
        }, (err) => {
            console.log(JSON.stringify(err));
        });
    }
}
